import React, { Fragment, Component } from "react";
import { properties } from '../../../constants/Propertise';
import { CardBody, CardHeader, Card, Button } from 'reactstrap';
import Filter from './Filter';
import Box from './Box';
import DefaultMessages from '../../DefaultMessages';
import { api } from "../../../api/api";
import moment from "moment";

class DashboardTiles extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hideFilter: false,
            headerSectionData: [],
            isPending: false,
            isSucess: false,
            isError: false
        }
    }

    componentDidMount() {
    }

    toggleFilter = () => {
        this.setState({ hideFilter: !this.state.hideFilter });
    }

    resetIncidentList = (filterData) => {
        let startDate = moment(filterData['startDate'], properties.dateFormat).format(properties.dateFormatFromDB);
        let endDate = moment(filterData['endDate'], properties.dateFormat).format(properties.dateFormatFromDB);
        let details = {
            startDate: startDate,
            endDate: endDate
        }
        this.getLabels(details);
    }

    filterIncidentList = (filterData) => {
        let startDate = moment(filterData['startDate'], properties.dateFormat).format(properties.dateFormatFromDB);
        let endDate = moment(filterData['endDate'], properties.dateFormat).format(properties.dateFormatFromDB);
        let details = {
            startDate: startDate,
            endDate: endDate
        }
        this.getLabels(details);
    }

    getLabels = (details) => {
        let allBrandUrl = 'dashboard/dashboardlabel';
        api.post(allBrandUrl, details)
            .then(allBrandResult => {
                if (allBrandResult.data !== "undefined") {
                    this.setState({
                        headerSectionData: allBrandResult.data
                    });
                } else {
                    this.setState({
                        headerSectionData: []
                    });
                }
            })
            .catch(error => {
                this.setState({
                    headerSectionData: []
                });
            });
    }

    getClassToBeApplied = () => {
        let numberOfKeys = this.state.headerSectionData.length;
        let classToBeApplied = 'col-lg-12';
        if (numberOfKeys === 2) {
            classToBeApplied = 'col-lg-6';
        } else if (numberOfKeys === 3) {
            classToBeApplied = 'col-lg-4';
        } else if (numberOfKeys >= 4) {
            classToBeApplied = 'col-lg-3';
        }

        return classToBeApplied;
    }

    render() {
        let classToBeApplied = this.getClassToBeApplied();

        return (
            <Fragment>
                <Card>
                    <CardHeader className='d-flex justify-content-between'>
                        <div>
                            {properties.networkAutomationText}
                        </div>
                        {/* <div className="col-md-12" style={{ textAlign: "right" }}> */}
                        <div>
                            <Button
                                title='Filter'
                                className="btn-shadow mr-2"
                                color="primary"
                                onClick={this.toggleFilter}
                            >
                                <i className="pe-7s-filter" />
                            </Button>
                        </div>
                    </CardHeader>
                    <CardBody id={"hideFilter-" + this.state.hideFilter}>
                        <Filter
                            resetFilter={this.resetIncidentList}
                            filterList={this.filterIncidentList}
                        />
                    </CardBody>
                    {
                        (
                            this.state.isPending === true ||
                            this.state.isError === true
                        ) ?
                            <DefaultMessages
                                isPending={this.state.isPending}
                                apiError={this.state.isError}
                                count={properties.pleaseWaitPageCount}
                            /> :
                            <Fragment>
                                <div className="row">
                                    {
                                        (this.state.headerSectionData.length > 0) &&
                                        <Fragment>
                                            {
                                                this.state.headerSectionData.map((eachObj, index) => {
                                                    return (
                                                        eachObj.transactionDetails === null
                                                            ?
                                                            <Fragment key={index}>
                                                                <Box
                                                                    text={eachObj.displayLabel}
                                                                    value={eachObj.displayValue}
                                                                    classToBeApplied="col-lg-4"
                                                                    color={eachObj.colorCode}
                                                                />
                                                            </Fragment>
                                                            :
                                                            <Fragment>
                                                                <div className="col-lg-12">
                                                                    <div
                                                                        // className="card-shadow-info m-3 widget-chart widget-chart2 card"
                                                                        className="card-shadow-info m-3 widget-chart widget-chart2 card"
                                                                        style={{ borderWidth: "1px", borderColor: eachObj.colorCode }}
                                                                    >
                                                                        <div className="widget-content">
                                                                            <div className="widget-content-outer">
                                                                                <div className="widget-content">
                                                                                    <div className="widget-numbers m-0" style={{ color: eachObj.colorCode, fontSize: "40px" }}>{eachObj.displayValue}</div>
                                                                                </div>
                                                                                <div className="widget-content fsize-1">
                                                                                    <div className="text-center opacity-8 mt-2"><span style={{ fontWeight: "bold" }}>{eachObj.displayLabel}</span></div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="row">
                                                                            {eachObj.transactionDetails?.map((innerObj, index2) => {
                                                                                return (
                                                                                    <Fragment key={index2}>
                                                                                        <Box
                                                                                            text={innerObj.displayLabel}
                                                                                            value={innerObj.displayValue}
                                                                                            classToBeApplied="col-lg-4"
                                                                                            color={innerObj.colorCode}
                                                                                        />
                                                                                    </Fragment>
                                                                                )
                                                                            })}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </Fragment>
                                                    )
                                                })
                                            }
                                        </Fragment>
                                    }
                                </div>
                            </Fragment>
                    }
                </Card>
            </Fragment>
        )
    }
}

export default DashboardTiles;